import React, {useCallback, useEffect} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {useNavigate} from 'react-router-dom';
import {markPostLoginPreferProjectList} from 'src/config/post-login-prefer-project-list';

export const Register = () => {
  const {loginWithRedirect, isAuthenticated, isLoading} = useAuth0();
  const navigate = useNavigate();

  const redirectToSignup = useCallback(() => {
    markPostLoginPreferProjectList();
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
      },
      appState: {
        returnTo: '/project',
      },
    });
  }, [loginWithRedirect]);

  useEffect(() => {
    const isLiveTest = process.env.REACT_APP_LIVE_TEST !== 'true';
    if (!isLoading && isLiveTest) {
      if (!isAuthenticated) {
        redirectToSignup();
      } else {
        navigate('/project');
      }
    }
  }, [isAuthenticated, isLoading, navigate, redirectToSignup]);

  return (
    <div>
      <button onClick={() => redirectToSignup()}>Register</button>
    </div>
  );
};
